import Controller from "../Engine/Controller";
//import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Tooltip extends Controller {

    constructor(dom) {
        super(dom, "Tooltip");

        this.tooltip = null;
        this. tooltipButton = null;
        this._tooltipButtonListenHandler = null;

        //Protected params
        let that = this,
            domNode = this.domNode;

        try{
            function _init() {
                that.tooltipButton = cfJS.querySelector(domNode, ">.itsTooltipButton");
                that.tooltip = cfJS.querySelector(domNode, ">.Tooltip");

                _connectHandlers();
            }

            function _connectHandlers() {
                if (that.tooltipButton)
                    that._tooltipButtonListenHandler = cfJS.addListener(that.tooltipButton, "click", function (e) {
                        that.showTooltip();
                    });
            }

            _init();
        } catch (e) {
            console.log ("Tooltip.constructor error: "+e);
        }
    }
    /*public*/
    options (param) {
        if (param.style)
            cfJS.style(this.tooltip, param.style);
    }

    setCoordinates() {
        let coordinates = this.tooltip.getBoundingClientRect(),
            windows_coordinates = document.body.getBoundingClientRect();

        //right
        if (coordinates.x+coordinates.width>windows_coordinates.width)
            cfJS.style(this.tooltip, "right", "0px");
    }

    showTooltip () {
        this.domNode.classList.toggle("show");

        this.setCoordinates();
    }
}

window.Tooltip = Tooltip;